export default "__VITE_ASSET__BwiwQBLC__"